import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { api } from '../lib/api'
import { Spinner, Tag, EmptyState } from '../components/ui/Primitives'

interface DomainRow {
  id: string
  hostname: string
  pathPrefix: string
  forceHttps: boolean
  discovered: boolean
  dnsVerifiedAt: string | null
  deployment: { id: string; name: string; app: { slug: string } }
  certificate: { notAfter: string; issuer: string } | null
}

export default function Domains() {
  const { data, isLoading } = useQuery({ queryKey: ['domains'], queryFn: () => api.get<DomainRow[]>('/domains') })
  if (isLoading) return <Spinner className="h-6 w-6" />

  return (
    <div className="space-y-5">
      <header>
        <h1 className="text-xl font-semibold">Dominios</h1>
        <p className="hint mt-0.5">{data?.length ?? 0} registrado(s)</p>
      </header>

      {(data ?? []).length === 0 ? (
        <EmptyState
          title="Todavía no hay dominios"
          hint="Los dominios se agregan desde la pestaña Dominios de cada instancia."
        />
      ) : (
        <div className="card divide-y divide-slate-800/60 p-0">
          {(data ?? []).map((d) => (
            <div key={d.id} className="flex flex-wrap items-center gap-3 px-5 py-3">
              <code className="min-w-0 flex-1 truncate font-mono text-sm">{d.hostname}</code>
              <Link to={`/instancias/${d.deployment.id}`} className="hint hover:text-slate-300">
                {d.deployment.app.slug} / {d.deployment.name}
              </Link>
              {d.forceHttps && <Tag tone="blue">HTTPS</Tag>}
              {d.dnsVerifiedAt ? <Tag tone="blue">DNS ok</Tag> : <Tag tone="slate">DNS sin verificar</Tag>}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
